import { Type } from '@angular/core'
import { Action } from '@ngrx/store'
import { PaymentIntent } from '@stripe/stripe-js'
import { EventTicketPackageEntity } from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.models'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'

export interface GbAppPayment {
  amount: string
  auction: string
  auction_payment_method_display_name: string
  created: string
  delegate: null | string
  fee_amount: string
  flat_fee: string
  initiator: string
  payment_action: string
  payment_method: string
  percentage_fee: string
  profile: string
  refunded: null | boolean
  status: PaymentStatusEnum
  refunded_amount: string
  stripe_charge: null
  stripe_payment_intent: GbPaymentIntent | null
  tax_amount: string
  tipping_fee_amount: string
  tipping_fee_percentage: string
  updated: string
  uuid: string
  volunteer: null | string
}

export interface GbPaymentIntent {
  amount: string
  auction: string
  created: string
  date_cancelled: null
  date_captured: null
  date_confirmed: null
  payment_intent: PaymentIntent
  payment_intent_id: string
  profile: string
  status: string
  stripe_connect: string
  updated: string
  uuid: string
}

export interface TippingFee {
  amount: number
  percent: number
}

export interface PaymentDonationOption {
  amount: number
  percent: number
}

export interface PaymentDonationButtonOption extends PaymentDonationOption {
  isMinimumAmount: boolean
}

export enum PaymentTypeEnum {
  Item = 'item',
  PreAuth = 'preAuth',
  Checkout = 'checkout',
  EventTicket = 'eventTicket',
}

export enum PaymentStatusEnum {
  Pending = 'pending',
  Succeeded = 'succeeded',
}

export interface GbPaymentDialogConfig {
  paymentType: PaymentTypeEnum
  paymentAmount?: number
  item?: ItemEntity | EventTicketPackageEntity
  quantity?: number
  onConfirmAction?: Action
  dynamicStep?: GbPaymentDynamicStep
}

export interface GbPaymentDynamicStep {
  title: string // mat dialog title
  label: string // mat step label
  component: Type<any>
}

export enum AddLiveBidPaymentResultEnum {
  PayNow = 'payNow',
  PayLater = 'payLater',
}

export enum PreAuthResultEnum {
  ManualCard = 'manualCard',
  DigitalWallet = 'digitalWallet',
}
